module.exports = __webpack_public_path__ + "static/img/rank_avatar_frame_challenger.9902f864.png";